import { render, staticRenderFns } from "./404.vue?vue&type=template&id=1df9a0a6&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=1df9a0a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df9a0a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1df9a0a6')) {
      api.createRecord('1df9a0a6', component.options)
    } else {
      api.reload('1df9a0a6', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=1df9a0a6&scoped=true", function () {
      api.rerender('1df9a0a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/frame/page/error/404.vue"
export default component.exports